// import "regenerator-runtime/runtime";
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers';
import Router from './router/router';

const toasterStyle = {
	containerStyle: {
		zIndex: 999999999999999,
	},
	toastOptions: {
		style: {
			zIndex: 999999999999999,
		},
	},
};

const App = () => {
	return (
		<LocalizationProvider dateAdapter={AdapterLuxon}>
			<BrowserRouter>
				<Toaster {...toasterStyle} />
				<Router />
			</BrowserRouter>
		</LocalizationProvider>
	);
};

export default App;
